import { timeOfDayGreeting as greeting } from "../../../../util/helper";
import WeatherComponent from "../../../../components/Weather/WeatherComponent";
import MainLogo from "../../../../components/Images/MainLogo"
import HomeButtonsContainer from "../../../../components/Containers/HomeButtonsContainer"
import "../../Home/Home.css";

export default function AdminHome({ user }) {
	return (
		<div className="d-flex flex-column flex-grow-1 home-container">
			<div className="d-flex justify-content-center">
				<div className="main-logo-container">
				<MainLogo />
				</div>
			</div>
			<div className="home-spacer">
				<h1 className="home-user-title">
					{greeting() + " " + user.firstName + "!"}
				</h1>
				<WeatherComponent />
			</div>
			<HomeButtonsContainer user={user}/>
		</div>
	);
}
